"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 3H1v18h22zm-2 16h-9v-6h9z"
}), 'BrandingWatermarkSharp');